
export default function Statistics() {
  const stats = [
    { value: '15+', label: 'Años de Experiencia', icon: 'ri-time-fill' },
    { value: '$2.5B+', label: 'Créditos Otorgados', icon: 'ri-money-dollar-circle-fill' },
    { value: '50,000+', label: 'Clientes Satisfechos', icon: 'ri-user-heart-fill' },
    { value: '3', label: 'Países de Operación', icon: 'ri-global-fill' },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl p-8 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-14 h-14 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-white text-2xl`}></i>
              </div>
              <h3 className="text-4xl font-bold text-slate-800 mb-2">{stat.value}</h3>
              <p className="text-sm text-slate-600">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
